module.exports = __webpack_public_path__ + "img/warn.ade5ef23.svg";